const punctuation = /[!"#$%'()*+,./:;<=>?@[\]^_`{|}~]/g

/**
 * @deprecated
 */
export const old = (id, title) => `/blog/${id}/${title.replace(' - ', ' ').replace(punctuation, '').replace(/\s/gi, '_')}`

export default (urlPermalink) => `/blog/${urlPermalink}`
